import React, { useEffect, useState } from "react";
import SimuladorComponent from "../../components/simulador/simulador.component";
import DatosComponent from "../../components/simulador/datos.component";
import { useParams } from "react-router-dom";
import {
  sendSimulator,
  vehiclesSimulator,
} from "../../components/conexion/vehicles.conexion";
import AmortizacionComponent from "../../components/simulador/amortizacion.component";

/*eslint-disable */

const SimuladorPage: React.FC = () => {
  const { vehiculo } = useParams();
  const [modelo, setModelo] = useState(vehiculo);
  const [modelos, setModelos] = useState([
    {
      modelo: "kona-gasolina",
      title: "KONA Gasolina",
      src: "../assets/00_Reservas/Gasolina.webp",
      precio: "1.000.000",
      reserva: "#",
      versiones: ["Premium", "Limited"],
    },
    {
      modelo: "kona-hibrida",
      title: "KONA Híbrida",
      src: "../assets/00_Reservas/hibrida.webp",
      precio: "1.000.000",
      reserva: "#",
      versiones: ["Premium", "Limited"],
    },
    {
      modelo: "kona-n-line",
      title: "KONA N Line",
      src: "../assets/00_Reservas/Nline.webp",
      precio: "1.000.000",
      reserva: "#",
      versiones: ["Premium"],
    },
    {
      modelo: "kona-electrica",
      title: "KONA Eléctrica",
      src: "../assets/00_Reservas/electrica.webp",
      precio: "1.000.000",
      reserva: "#",
      versiones: [""],
    },
  ]);
  const [version, setVersion] = useState("");
  const [politica_1, setPolitica_1] = useState(false);
  const [politica_2, setPolitica_2] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0); // Inicialmente se muestra la imagen en el centro
  const [cuotaInicial, setCuotaInicial] = useState("0");
  const [plazo, setPlazo] = useState(72);
  const [frecuenciaPago, setFrecuenciaPago] = useState("m");
  const [diaPago, setDiaPago] = useState(17);
  const [tipoPlan, setTipoPlan] = useState("Tradicional");
  const [cuotaExtra, setCuotaExtra] = useState("0");
  const [send, setSend] = useState(false);
  const [amortizacion, setAmortizacion] = useState([]);
  const [vehiculos, setVehiculos]: any = useState([]);
  useEffect(() => {
    // Accedemos directamente a la etiqueta body
    const bodyElement = document.body;

    // Añadir la clase deseada a body
    bodyElement.classList.remove("active"); //
    vehiclesSimulator().then(function (res: any) {
      let data: any = res.data.data;
      setVehiculos(data);
      setModelo(
        vehiculo !== undefined && vehiculo !== "" ? vehiculo : data[0].slug
      );
      setVersion(
        vehiculo !== undefined && vehiculo !== ""
          ? data?.find((item: any) => item.slug === vehiculo)?.versions[0]?.name
          : data[0]?.versions[0]?.name
      );
    });
  }, []);

  useEffect(() => {
    if (send) {
      sendSimulator({
        ValorVehiculo: vehiculos
          ?.find((item: any) => item.slug === modelo)
          ?.versions?.find((e: any) => e.name === version)?.price,
        Accesorios: 0,
        CuotaInicial: cuotaInicial,
        Plazo: plazo,
        UnidadTiempo: "m",
        DiaPago: diaPago,
        Plan: "Tradicional",
        SeguroVida: true,
        TipoSeguroVida: "PrimaAnual",
        CuotaExtra: 0,
      }).then(function (res: any) {
        let data: any = res.data;
        console.log(data);
        setAmortizacion(data);
      });
    }
  }, [send]);

  const [isVisible, setIsVisible] = React.useState(false);
  const ref = React.useRef<HTMLDivElement | null>(null);
  React.useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else if (entry.boundingClientRect.top > 0) {
          setIsVisible(false);
        }
      },
      {
        threshold: 0.1,
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  return (
    <>
      <div id="simulador" ref={ref} className={`home-page`} style={{ backgroundColor: "#F6F3F2" }}>
        <div className={`simulador-home-finance ${isVisible ? "visible" : ""}`}>
          <h1
            style={{ position: "absolute", opacity: "0", pointerEvents: "none" }}
          >
            Simulador Hyundai Colombia - Encuentra tu Próximo Vehículo
          </h1>

          <div className="home-page-mascara"></div>

          {!send ? (
            <div className="simulador-component">
              <div
                className="carrousel-simulador-component"
                style={{
                  transform: `translateX(-${currentIndex * 100}%)`,
                }}
              >
                <SimuladorComponent
                  modelo={modelo}
                  setModelo={setModelo}
                  modelos={modelos}
                  setModelos={setModelos}
                  version={version}
                  setVersion={setVersion}
                  politica_1={politica_1}
                  setPolitica_1={setPolitica_1}
                  politica_2={politica_2}
                  setPolitica_2={setPolitica_2}
                  setCurrentIndex={setCurrentIndex}
                  vehiculos={vehiculos}
                />
                <DatosComponent
                  modelo={modelo}
                  modelos={modelos}
                  version={version}
                  setCurrentIndex={setCurrentIndex}
                  cuotaInicial={cuotaInicial}
                  setCuotaInicial={setCuotaInicial}
                  plazo={plazo}
                  setPlazo={setPlazo}
                  frecuenciaPago={frecuenciaPago}
                  setFrecuenciaPago={setFrecuenciaPago}
                  diaPago={diaPago}
                  setDiaPago={setDiaPago}
                  tipoPlan={tipoPlan}
                  setTipoPlan={setTipoPlan}
                  cuotaExtra={cuotaExtra}
                  setCuotaExtra={setCuotaExtra}
                  setSend={setSend}
                  vehiculos={vehiculos}
                />
              </div>
            </div>
          ) : (
            <AmortizacionComponent
              modelo={modelo}
              version={version}
              cuotaInicial={cuotaInicial}
              plazo={plazo}
              frecuenciaPago={frecuenciaPago}
              diaPago={diaPago}
              tipoPlan={tipoPlan}
              cuotaExtra={cuotaExtra}
              amortizationData={amortizacion}
              vehiculos={vehiculos}
              setSend={setSend}
            />
          )}
        </div>
      </div>
      
    </>
  );
};

export default SimuladorPage;
